<script setup lang="ts">
const { t, te } = useI18n();
const route = useRoute();
const site = useSiteData();
const { localized } = useLocaleValue();

const siteName = computed(() => localized<string>(site.website_name));
const defaultDescription = computed(() => localized<string>(site.default_description));
const pageName = computed(() => route.meta.page_name as string | undefined);
const titleKey = computed(() => (pageName.value ? `${pageName.value}.meta.title` : undefined));
const descriptionKey = computed(() =>
  pageName.value ? `${pageName.value}.meta.description` : undefined
);
const robots = computed(() => (route.meta.robots as string | undefined) ?? "index, follow");

if (import.meta.dev) {
  watchEffect(() => {
    if (!pageName.value) {
      console.warn(`[layout] Missing 'page_name' route meta for path: ${route.path}`);
      return;
    }

    if (titleKey.value && !te(titleKey.value)) {
      console.warn(`[layout] Missing i18n key: ${titleKey.value}`);
    }

    if (descriptionKey.value && !te(descriptionKey.value)) {
      console.warn(`[layout] Missing i18n key: ${descriptionKey.value}`);
    }
  });
}

useHead(() => ({
  title: titleKey.value ? t(titleKey.value) : undefined,
  titleTemplate: (titleChunk?: string | null) => {
    if (!titleChunk || titleChunk === siteName.value) {
      return siteName.value;
    }
    return `${titleChunk} - ${siteName.value}`;
  },
  meta: [
    {
      name: "description",
      content: descriptionKey.value ? t(descriptionKey.value) : defaultDescription.value,
    },
    {
      name: "robots",
      content: robots.value,
    },
  ],
}));
</script>

<template>
  <div class="site-shell">
    <Header />
    <main>
      <slot />
    </main>
    <CookieConsent />
    <Footer />
  </div>
</template>
